import {MenopauseAppointmentItem} from '@progyny/pages/Consultations/Menopause/useMenopauseConsultationAppointments'

type SessionStatus = {
  session?: {sessionNumber?: number | null; title?: string | null} | null
  appointment?: {id?: string | null} | null
} | null

export function normalizeProgramAppointment(
  apt: any,
  sessionStatuses: SessionStatus[] | undefined
): MenopauseAppointmentItem | null {
  if (!apt?.id) return null
  const program = apt.programEnrollment?.program
  const consultation = apt.consultationEnrollment?.consultation
  const isConsultationOnboarding = !!consultation

  const sessionStatus = sessionStatuses?.find(
    (ss) => ss?.appointment?.id === apt.id
  )
  const sessionNumber = sessionStatus?.session?.sessionNumber ?? undefined
  const sessionTitle = isConsultationOnboarding
    ? (consultation?.title ?? 'Your onboarding call')
    : (sessionStatus?.session?.title ??
      program?.sessions?.[0]?.title ??
      program?.title ??
      'Emotional support')

  return {
    id: apt.id,
    scheduledTime: apt.scheduledTime,
    status: apt.status ?? 'SCHEDULED',
    type: isConsultationOnboarding ? 'onboarding' : 'emotional_program',
    title: sessionTitle ?? 'Emotional support',
    description: program?.description ?? undefined,
    programSlug: program?.slug ?? undefined,
    sessionNumber: sessionNumber != null ? Number(sessionNumber) : undefined,
    appointment: {
      id: apt.id,
      calcomBookingUid: apt.calcomBookingUid,
      canReschedule: apt.canReschedule,
      canJoin: apt.canJoin,
      meetingLink: apt.meetingLink,
      bookingLanguage: apt.bookingLanguage,
    },
  }
}
